import React from 'react';
import KiteImageSource from './assets/kite.svg';

interface CurrentPlanInfo {
  name: string;
}

interface OfferPlanInfo {
  features: string[];
}

interface CancelOfferPlanDescriptionProps {
  currentPlanInfo: CurrentPlanInfo;
  offerPlanInfo: OfferPlanInfo;
}

const CancelOfferPlanDescription: React.FC<CancelOfferPlanDescriptionProps> = ({
  currentPlanInfo,
  offerPlanInfo,
}) => {
  const planName = currentPlanInfo.name;
  const calloutText = `If you downgrade, you'll miss out on these great ${planName} features:`;

  const callout = (
    <div className="m-cancel-offer-plan-description--callout">
      {calloutText}
    </div>
  );

  const planFeatures = offerPlanInfo.features;
  const features = (
    <ul>
      {planFeatures.map((feat, index) => (
        <li key={`feature-${index}`}>{feat}</li>
      ))}
    </ul>
  );

  const readMoreLink = <a href="/info/tour">Read more about our features.</a>;

  const imageStyle: React.CSSProperties = {
    marginTop: -5,
    marginLeft: -15,
  };

  const kiteImage = (
    <img
      src={KiteImageSource}
      style={imageStyle}
      alt="Decorative kite illustration"
    />
  );

  return (
    <div className="m-cancel-offer-plan-description">
      {callout}
      {features}
      {readMoreLink}
      {kiteImage}
    </div>
  );
};

export default CancelOfferPlanDescription;
